import api from "actions/api.js"


export function search(criteria) {
    return api("search", 
        {
            method: "POST",
            body: JSON.stringify(criteria)
        })
}

export function getCV(ids) {
    return api("cv",
        {
            method: "POST",
            body: JSON.stringify(ids)
        })
}

export function getAnonymCV(ids) {
    return api("anonymcv",
        {
            method: "POST",
            body: JSON.stringify(ids)
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/search/api.js
 **/